// Core modules
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Delete dialog component
 */
@Component({
    selector: 'app-delete',
    templateUrl: './delete.component.html',
    styleUrls: ['./delete.component.scss'],
    standalone: false
})
export class DeleteDialogComponent implements OnInit {

  id: string;

  /**
   * Life cycle method
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  /**
   * Life cycle init method
   */
  ngOnInit(): void {
    this.id = this.data;
  }

}
